import React from "react";
import Button from "components/Common/Button";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./style.scss";

const BLOCK_NAME = "ButtonGroupMultiSelect";

class ButtonGroupMultiSelect extends React.Component {
  /**
   * @param {String} selectedValue
   */
  handleButtonSelect(selectedValue) {
    const { values, onChange } = this.props;
    let newValues;

    // if selectedValue exist in values already, remove it
    if (values.indexOf(selectedValue) >= 0) {
      newValues = values.filter(value => value !== selectedValue);
    } else {
      newValues = [...values, selectedValue];
    }

    onChange(newValues);
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      values, options, customClassName, invalidFields, isInvalid
    } = this.props;

    const renderButtons = options.map((button) => {
      const selected = values.indexOf(button.value) >= 0;

      return (
        <Button
          key={button.value}
          title={button.altText || button.value}
          customClassName={classNames(
            `${BLOCK_NAME}__button`, {
              [`${BLOCK_NAME}__button--active`]: selected,
              [`${BLOCK_NAME}__button--invalid`]: invalidFields.includes(button.value)
            }
          )}
          onClick={() => this.handleButtonSelect(button.value)}
          text={button.label}
        />
      );
    });

    return (
      <div className={classNames(BLOCK_NAME,
        customClassName,
        {
          [`${BLOCK_NAME}--invalid`]: isInvalid
        })}
      >
        {renderButtons}
      </div>
    );
  }
}

ButtonGroupMultiSelect.propTypes = {
  values: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number)
  ]),
  invalidFields: PropTypes.arrayOf(PropTypes.string),
  isInvalid: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  customClassName: PropTypes.string
};

ButtonGroupMultiSelect.defaultProps = {
  values: [],
  invalidFields: [],
  customClassName: null,
  isInvalid: false
};

export default ButtonGroupMultiSelect;
